import { Button, Card, Col, Form, Row } from "react-bootstrap";
import PageTemplate from "../../templates/Pagetemplate";
import BreadCrumb from "../../molecules/BreadCrumb";
import InputGroupValidation from "../../molecules/InputGroupValidation";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { hideConfirm, showConfirm } from "../../../../reducer/confirmSlice";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { hideAlert, showAlert } from "../../../../reducer/alertSlice";
import MobileAuth from "../../molecules/MobileAuth";
import { useEffect, useState } from "react";
import { useCheckDirtyField, useLogout } from "../../../common/hook";
import axios from "axios";
import Loading from "../../organisms/Loading";

export default function DeailAdmin(props) {
    const { id } = useParams();
    const [phone, setPhone] = useState();
    const [time, setTime] = useState(Date.now());
    const {
        register,
        handleSubmit,
        getValues,
        setValue,
        watch,
        formState: { errors },
    } = useForm();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loginInfo = useSelector(state => state.login);
    const logout = useLogout();


    const {checkFieldConfirm} = useCheckDirtyField();

    const [dirty, setDirty] = useState(false);

    // 상세 정보
    const {data, isLoading} = useQuery({
        queryKey: ["adminDetail", id, time],
        refetchOnWindowFocus: false,
        queryFn: () => axios("/admin/detail/"+id, {
            method: "GET",
        }).then(result => {
            setPhone(result.data.phone);
            return result.data;
        })
    });

    // 최고관리자 등록 계정 개수 체크
    const checkAdminTotal = useQuery({
        queryKey: ["checkAdminTotal"],
        queryFn: () => axios("/admin/list", {
            method: "POST",
            data: {
                "orderField": "register_time",
                "order": "desc",
                "page": 1,
                "perPage": 10,
            }
        }).then(result => {
            const total = result.data.data.total;
            if (total > 1) {
                dispatch(showConfirm({
                    msg: <>계정 삭제 시 관리자 접속이 불가합니다.<br/>정말 해당 계정을 삭제하시겠어요?</>,
                    func: () => {
                        deleteAdmin.mutate();
                        dispatch(hideAlert());
                    }
                }))
            } else {
                dispatch(showAlert({
                    msg: <>계정 삭제가 불가합니다.<br/>최소 1개 이상의 최고 관리자가<br/>등록되어 있어야합니다.</>
                }))
            }
            return result;
        }),
        refetchOnWindowFocus: false,
        enabled: false
    });

    // 수정
    const updateAdmin = useMutation({
        mutationKey: ['updateAdmin'],
        mutationFn: () => axios("/admin/update/"+id,{
            method: "PUT",
            data: getValues()
        }).then(result => {
            if (result.status == "201") {
                dispatch(showAlert({
                    msg: "수정되었습니다.",
                    func: () => {
                        navigate(-1)
                    }
                }))
            }
            return result;
        })
    })

    // 삭제
    const deleteAdmin = useMutation({
        mutationKey: ['deleteAdmin'],
        retry: 1,
        mutationFn: () => axios("/admin/delete/"+id,{
            method: "DELETE",
        }).then(result => {
            if (result.status == "204") {
                dispatch(hideConfirm());
                dispatch(showAlert({
                    msg: "삭제가 완료되었습니다.",
                    func: () => {
                        if (id == loginInfo.admin.id) {
                            logout.refetch();
                        }
                        navigate("/admin/list/chief");
                    }
                }))
            }
            return result;
        })
    })

    useEffect(() => {
        setValue("phone", phone);
    },[phone]);

    
    useEffect(() => {
        const subscription = watch((value) => {
            if (data.data) {
                for (const key in data.data) {
                    if (data.data[key] != value[key]) {
                        if (key == "name" || key == "position" || key == "phone") {
                            setDirty(true);
                        }
                    }
                }
            }
        });
        return () => subscription.unsubscribe();
    },[watch, data]);

    useEffect(() => {
        if (deleteAdmin.isError) {
            if (deleteAdmin.error.response) {
                if (deleteAdmin.error.response.status == 403) {
                    navigate("/error/accessDenied");
                } else {
                    dispatch(showAlert({
                        msg: deleteAdmin.error.response.data.msg.ko,
                        func: () => {
                            navigate(-1);
                        }
                    }))
                }
            }
        }

    },[deleteAdmin.isError]);

    if (isLoading) {
        return <Loading />
    }

    if (data) {
        return (
            <>
                <PageTemplate.Top>
                    <BreadCrumb arr={[<Link to="/admin/list/company">관리자 설정</Link>, <Link to="/admin/list/chief/">최고 관리자</Link>, <span className="fw-bold">최고 관리자 상세</span>]} />
                    <h1 className="page-title">최고 관리자 상세</h1>
                </PageTemplate.Top>
    
                <PageTemplate.Content>
                    <Card className="mt-4 overflow-hidden">
                        <Card.Header className="d-flex justify-content-between align-center">
                            <Card.Title className="fs-3 mb-0">관리자 정보</Card.Title>
                            <span className="small text-secondary">등록일시 | {data.data.registerTime}</span>
                        </Card.Header>
    
                        <Card.Body>
                            <Form.Group as={Row} className="mb-3" controlId="formPhone">
                                <Form.Label column sm="2">
                                    휴대폰 번호 *
                                </Form.Label>
                                <Col sm="8">
                                    <MobileAuth 
                                        type="3"
                                        id={id}
                                        certifiedNum={data.data.phone}
                                        addValue={(value) => {
                                            setPhone(value);
                                        }} 
                                        removeValue={() => {
                                            setPhone(null);
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" controlId="formPosition">
                                <Form.Label column sm="2">
                                    직책 *
                                </Form.Label>
                                <Col sm="8">
                                    <InputGroupValidation
                                        register={register("position", {
                                            required: "직책을 입력해주세요",
                                        })} 
                                        invalid={errors['position']}
                                        placeholder="직책을 입력하세요" 
                                        defaultValue={data.data.position}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-5" controlId="formName">
                                <Form.Label column sm="2">
                                    이름 *
                                </Form.Label>
                                <Col sm="8">
                                    <InputGroupValidation
                                        register={register("name", {
                                            required: "이름을 입력해주세요",
                                        })} 
                                        invalid={errors['name']}
                                        placeholder="이름을 입력하세요" 
                                        defaultValue={data.data.name}
                                    />
                                </Col>
                            </Form.Group>
                            
                            <Row>
                                <Col sm="2">
                                    <p className="small text-secondary">
                                        최근 접속일시
                                    </p>
                                </Col>
                                <Col sm="8">
                                    <p className="small text-secondary">
                                        {data.data.lastLoginTime}
                                    </p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </PageTemplate.Content>
    
                <PageTemplate.ButtonContainer className="justify-content-between">
                    <Button variant="outline-danger" onClick={() => {
                        checkAdminTotal.refetch();
                    }}>삭제</Button>
    
                    <div className="d-flex gap-2">
                        <Button variant="outline-secondary" onClick={() => {
                            checkFieldConfirm(dirty);
                        }}>취소</Button>
                        <Button variant="primary" onClick={handleSubmit(() => {
                            if (!getValues().phone) {
                                dispatch(showAlert({
                                    msg: "휴대폰 번호를 인증해주세요"
                                }))
                            } else {
                                updateAdmin.mutate();
                            }
                        })}>수정</Button>
                    </div>
                </PageTemplate.ButtonContainer>
            </>
        );
    }
}
